import { LitElement, html, css } from 'lit-element';
import './loading-logo';
import './history-card';

export class HistoryBase extends LitElement {
    static get styles() {
        return [
            css`
                :host {
                    display: block;
                }

                .history-list {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }

                .empty-state {
                    border: 1px dashed #cbd5e1;
                    border-radius: 8px;
                    padding: 16px;
                    color: #475569;
                }
            `,
        ];
    }

    static get properties() {
        return {
            historyRecords: {
                type: Array,
            },
            authorizations: {
                type: Array,
            },
            isLoadingHistory: {
                type: Boolean,
            },
        };
    }

    get historyTitle() {
        return 'History';
    }

    get emptyMessage() {
        return 'No history found.';
    }

    get fieldColumnWidth() {
        return '180px';
    }

    renderHistoryCard(historyRecord) {
        return html`<history-card
            .historyRecord=${historyRecord}
            .fieldColumnWidth=${this.fieldColumnWidth}></history-card>`;
    }

    render() {
        return html`
            <h2>${this.historyTitle}</h2>
            <div>${this.renderHistoryList()}</div>
        `;
    }

    renderLoading() {
        return html`<loading-logo></loading-logo>`;
    }

    renderHistoryList() {
        const { historyRecords = [], isLoadingHistory } = this;
        if (isLoadingHistory) {
            return this.renderLoading();
        }
        if (!historyRecords.length) {
            return html`<div class="empty-state">${this.emptyMessage}</div>`;
        }

        return html`
            <div class="history-list">
                ${historyRecords.map((historyRecord) => this.renderHistoryCard(historyRecord))}
            </div>
        `;
    }
}
